import { render, staticRenderFns } from "./AppMobile.vue?vue&type=template&id=7b891a66&scoped=true&"
import script from "./AppMobile.vue?vue&type=script&lang=ts&"
export * from "./AppMobile.vue?vue&type=script&lang=ts&"
import style0 from "./AppMobile.vue?vue&type=style&index=0&id=7b891a66&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b891a66",
  null
  
)

export default component.exports